import Vue from 'vue'
import VueRouter, {Route, RouteConfig} from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'first',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/helpManual',
    name: 'helpManual',
    component: () => import( '../views/pages/CaoZuoShouCe.vue')
  },
  {
    path: '/pdfviewer',
    name: 'pdfViewer',
    component: () => import( '../views/PDFViewer.vue')
  },
  {
    path: '/treeTable',
    name: 'treeTable',
    component: () => import( '../views/TreeTable.vue')
  },
  {
    path: '/result',
    name: 'result',
    meta: {title: "认证结果"},
    component: () => import( '../views/public/Result.vue')
  },
  {
    path: '/h/:moduleId',
    name: 'Home',
    component: () => import( '../views/Home.vue'),
  },
  {
    path: '/auth/callback',
    name: 'Auth_CallBack',
    component: () => import('../views/oauth2/AuthorizeSJ.vue'),
  },
  {
    path: '/page',
    name: 'pageHome',
    meta: {title: "主页"},
    component: () => import( '../views/pages/Home.vue'),
    children: [
      {
        path: '/homepage',
        name: 'homepage',
        meta: {title: "主页"},
        component: () => import( '../views/pages/Homepage.vue')
      },
      {
        path: '/list',
        name: 'pageIndex',
        meta: {title: "主页-选模块"},
        component: () => import( '../views/pages/Index.vue')
      },
      {
        path: '/register-user',
        name: 'register-user',
        meta: {title: "个人注册"},
        component: () => import( '../views/pages/RegisterUserV2.vue')
      },

      {
        path: '/register-company-select',
        name: 'register-company-select',
        meta: {title: "单位注册"},
        component: () => import( '../views/pages/RegisterCompanySelect.vue')
      },
      {
        path: '/change-mechanism-index',
        name: 'change-mechanism-index',
        meta: { title: "单位变更"},
        component: () => import( '../views/mechanism/change/Index.vue'),
      },
      {
        path: '/change-mechanism-select',
        name: 'change-mechanism-select',
        meta: { title: "单位变更"},
        component: () => import( '../views/mechanism/change/Select.vue'),
      },
      {
        path: '/change-mobile',
        name: 'change-mobile',
        meta: {title: "更换手机号"},
        component: () => import( '../views/pages/ChangeMobile.vue')
      },
      {
        path: '/register-company',
        name: 'register-company',
        meta: {title: "单位注册"},
        component: () => import( '../views/pages/RegisterCompany.vue')
      },
      {
        path: '/register-company-v2',
        name: 'register-company-v2',
        meta: {title: "单位注册"},
        component: () => import( '../views/pages/RegisterCompanyV2.vue')
      },
      {
        path: '/jump',
        name: 'jump',
        meta: {title: "判断菜单跳转"},
        component: () => import( '../views/pages/Jump.vue')
      },
      {
        path: '/instrument/list/:check/:showOnly/:region',
        name: 'instrumentList',
        meta: { title: "器具列表" },
        component: () => import( '../views/instrument/List.vue'),
      },
      {
        path: '/instrument/detail/:type/:id',
        name: 'instrumentDetail',
        meta: { title: "器具详情" },
        component: () => import( '../views/instrument/Detail.vue'),
      },
      {
        path: '/manufactory/list',
        name: 'manufactoryList',
        meta: { title: "制造单位列表" },
        component: () => import( '../views/manufactory/List.vue'),
      },
      {
        path: '/inspection/list',
        name: 'inspectionList',
        meta: { title: "检定申请列表" },
        component: () => import( '../views/inspection/List.vue'),
      },
      {
        path: '/inspection/detail/:id',
        name: 'inspectionDetail',
        meta: { title: "检定申请详情" },
        component: () => import( '../views/inspection/Detail.vue'),
      },
      {
        path: '/inspection/edit/:id/:type/:orderId',
        name: 'inspectionEdit',
        meta: { title: "检定申请编辑" },
        component: () => import( '../views/inspection/Edit.vue'),
      },

      {
        path: '/audit/list',
        name: 'auditList',
        meta: { title: "备案申请列表" },
        component: () => import( '../views/audit/List.vue'),
      },
      {
        path: '/audit/detail/:id/:type',
        name: 'auditDetail',
        meta: { title: "备案申请详情" },
        component: () => import( '../views/audit/Detail.vue'),
      },
      {
        path: '/adminOrgan/list',
        name: 'adminOrganList',
        meta: { title: "器具备案" },
        component: () => import( '../views/adminOrgan/List.vue'),
      },
      {
        path: '/adminOrgan/detail/:id/:type',
        name: 'adminOrganDetail',
        meta: { title: "器具备案批量审核" },
        component: () => import( '../views/adminOrgan/Detail.vue'),
      },
      {
        path: '/technical/list',
        name: 'technicalList',
        meta: { title: "器具检定列表" },
        component: () => import( '../views/technical/List.vue'),
      },
      {
        path: '/technical/detail/:id/:orderId/:type',
        name: 'technicalDetail',
        meta: { title: "器具检定详情" },
        component: () => import( '../views/technical/Detail.vue'),
      },
      {
        path: '/measuring/list/:mode',
        name: 'measuringList',
        meta: { title: "计量标准管理" },
        component: () => import( '../views/measuring/List.vue'),
      },
      {
        path: '/measuring/detail/:pageType/:id',
        name: 'measuringDetail',
        meta: { title: "计量标准详情页" },
        component: () => import( '../views/measuring/Detail.vue'),
      },
      {
        path: '/standard/publicList/:mode',
        name: 'standardPublicList',
        meta: { title: "社会公用计量标准" },
        component: () => import( '../views/standard/PublicList.vue'),
      },
      {
        path: '/standard/publicDetail/:id/:type',
        name: 'standardPublicDetail',
        meta: { title: "社会公用计量标准详情" },
        component: () => import( '../views/standard/PublicDetail.vue'),
      },
      {
        path: '/authorizeCert/CompanyList',
        name: 'authorizeCompanyList',
        meta: { title: "所在单位管理" },
        component: () => import( '../views/authorizeCert/CompanyList.vue'),
      },
      {
        path: '/cert/list/:mode/:modeValue/:modeType/:orgId',
        name: 'authorizeCertList',
        meta: { title: "计量授权证书列表" },
        component: () => import( '../views/authorizeCert/ListV2.vue'),
      },
      {
        path: '/authorizeCert/detail/:pageType/:mode/:manageStatus/:id',
        name: 'authorizeCertDetail',
        meta: { title: "计量授权证书详情" },
        component: () => import( '../views/authorizeCert/Detail.vue'),
      },
      {
        path: '/external/:url',
        name: 'external',
        meta: { title: "计量行政管理部门列表-外部链接" },
        component: () => import( '../views/external/List.vue'),
      },
      {
        path: '/personList/:type',
        name: 'personList',
        meta: { title: "人员信息管理" },
        component: () => import( '../views/information/PersonList.vue'),
      },
      //
      // {
      //   path: '/mechanism/list/:mode',
      //   name: 'mechanismList',
      //   meta: { title: "单位信息管理" },
      //   component: () => import( '../views/mechanism/List.vue'),
      // },
      {
        path: '/qj',
        name: 'qj',
        component: () => import( '../views/sys/Index.vue'),
        meta: { moduleId: 27 },
        children: [
          {
            path: '/home/27',
            name: 'Qj_Home',
            meta: {title: "我的主页", menu: '/home/27', moduleId: 27},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/qj/instrument-0-1-0/list/:check/:showOnly/:region',
            name: 'Qj_instrument-0-1-0',
            meta: { title: "非强检计量器具台账", menu: '/qj/instrument-0-1-0/list/0/1/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument-1-1-0/list/:check/:showOnly/:region',
            name: 'Qj_instrument-1-1-0',
            meta: { title: "强检计量器具台账", menu: '/qj/instrument-1-1-0/list/1/1/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument-1-1-2/list/:check/:showOnly/:region',
            name: 'Qj_instrument-1-1-2',
            meta: { title: "检定强检器具", menu: '/qj/instrument-1-1-2/list/1/1/2',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument-0-1-2/list/:check/:showOnly/:region',
            name: 'Qj_instrument-0-1-2',
            meta: { title: "检定/校准非强检器具", menu: '/qj/instrument-0-1-2/list/0/1/2',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/audit/list',
            name: 'Qj_auditList',
            meta: { title: "强检计量器具备案", menu: '/qj/audit/list', name: "auditList", keepAlive: true },
            component: () => import( '../views/audit/List.vue'),
          },
          {
            path: '/qj/audit/detail/:id/:type',
            name: 'Qj_auditDetail',
            meta: { title: "备案申请详情", menu: '/qj/audit/list', name: "auditDetail" },
            component: () => import( '../views/audit/Detail.vue'),
          },
          {
            path: '/qj/inspection/list',
            name: 'Qj_inspectionList',
            meta: { title: "强检计量器具检定", menu: '/qj/inspection/list',name: "inspectionList", keepAlive: true },
            component: () => import( '../views/inspection/List.vue'),
          },
          {
            path: '/qj/external/:url',
            name: 'Qj_external',
            meta: { title: "强检计量器具检定" },
            component: () => import( '../views/external/Page.vue'),
          },
          {
            path: '/qj/inspection/detail/:id/:orderApplyId',
            name: 'Qj_inspectionDetail',
            meta: { title: "检定申请详情", menu: '/qj/inspection/list', name: "inspectionDetail" },
            component: () => import( '../views/inspection/Detail.vue'),
          },
          {
            path: '/qj/inspection/edit/:id/:type/:orderId',
            name: 'Qj_inspectionEdit',
            meta: { title: "检定申请编辑", menu: '/qj/inspection/list',name: "inspectionEdit" },
            component: () => import( '../views/inspection/Edit.vue'),
          },
          {
            path: '/qj/adminOrgan/list',
            name: 'Qj_adminOrganList',
            meta: { title: "强检计量器具备案", menu: '/qj/adminOrgan/list', name: "adminOrganList", keepAlive: true },
            component: () => import( '../views/adminOrgan/List.vue'),
          },
          {
            path: '/qj/adminOrgan/detail/:id/:type',
            name: 'Qj_adminOrganDetail',
            meta: { title: "器具备案批量审核", menu: '/qj/adminOrgan/list', name: "adminOrganDetail"},
            component: () => import( '../views/adminOrgan/Detail.vue'),
          },
          {
            path: '/qj/technical/list',
            name: 'Qj_technicalList',
            meta: { title: "强检计量器具检定", menu: '/qj/technical/list', name: "technicalList", keepAlive: true },
            component: () => import( '../views/technical/List.vue'),
          },
          {
            path: '/qj/technical/noMatchDetail/:orderApplyId',
            name: 'Qj_noMatchDetail',
            meta: { title: "业务详情", menu: '/qj/technical/noMatchDetail', name: "qj_noMatchDetail" },
            component: () => import( '../views/technical/NoMatchDetail.vue'),
          },
          {
            path: '/qj/technical/detail/:id/:orderId/:type',
            name: 'Qj_technicalDetail',
            meta: { title: "器具检定详情", menu: '/qj/technical/list',name: "technicalDetail" },
            component: () => import( '../views/technical/Detail.vue'),
          },
          {
            path: '/qj/mechanismAll/list/:mode',
            name: 'Qj_mechanismAll',
            meta: { title: "全部单位管理", menu: '/qj/mechanismAll/list/0000', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismSelf/list/:mode',
            name: 'Qj_mechanismSelf',
            meta: { title: "所在单位管理", menu: '/qj/mechanismSelf/list/0005', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismUse/list/:mode',
            name: 'Qj_mechanismUse',
            meta: { title: "器具使用单位", menu: '/qj/mechanismUse/list/0004', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismOfficial/list/:mode',
            name: 'Qj_mechanismOfficial',
            meta: { title: "法定技术机构", menu: '/qj/mechanismOfficial/list/0001', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismOther/list/:mode',
            name: 'Qj_mechanismOther',
            meta: { title: "其他技术机构", menu: '/qj/mechanismOther/list/0003', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismOffice/list/:mode',
            name: 'Qj_mechanismOffice',
            meta: { title: "计量行政部门", menu: '/qj/mechanismOffice/list/0002', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismEmpower/list/:mode',
            name: 'Qj_mechanismEmpower',
            meta: { title: "授权检定机构", menu: '/qj/mechanismEmpower/list/0006', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismSpecial/list/:mode',
            name: 'Qj_mechanismSpecial',
            meta: { title: "专项授权检定机构", menu: '/qj/mechanismSpecial/list/0008', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/mechanismProduce/list/:mode',
            name: 'Qj_mechanismProduce',
            meta: { title: "器具制造单位", menu: '/qj/mechanismProduce/list/300', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/qj/personListSelf/:type',
            name: 'Qj_personListSelf',
            meta: { title: "所在单位人员管理", menu: '/qj/personListSelf/5', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/personListUse/:type',
            name: 'Qj_personListUse',
            meta: { title: "器具使用单位人员", menu: '/qj/personListUse/0004', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/personListOfficial/:type',
            name: 'Qj_personListOfficial',
            meta: { title: "法定技术机构人员", menu: '/qj/personListOfficial/0001', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/personListEmpower/:type',
            name: 'Qj_personListEmpower',
            meta: { title: "授权检定机构人员", menu: '/qj/personListEmpower/0006', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/personListSpecial/:type',
            name: 'Qj_personListSpecial',
            meta: { title: "专项授权检定人员", menu: '/qj/personListSpecial/0008', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/personListProduce/:type',
            name: 'Qj_personListProduce',
            meta: { title: "器具制造单位人员", menu: '/qj/personListProduce/0007', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/personListOther/:type',
            name: 'Qj_personListOther',
            meta: { title: "其他技术机构人员", menu: '/qj/personListOther/0003', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/personListOffice/:type',
            name: 'Qj_personListOffice',
            meta: { title: "计量行政部门人员", menu: '/qj/personListOffice/0002', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/qj/userData/:type/:show/:id',
            name: 'Qj_inforUserData',
            meta: {title: "人员信息", menu: '/qj/userData/3/0/0', name: "userData"},
            component: () => import( '../views/pages/UserData.vue')
          },
          {
            path: '/qj/instrument-1-0-0/list/:check/:showOnly/:region',
            name: 'Qj_instrument-1-0-0',
            meta: { title: "强检计量器具信息", menu: '/qj/instrument-1-0-0/list/1/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument-0-0-0/list/:check/:showOnly/:region',
            name: 'Qj_instrument-0-0-0',
            meta: { title: "非强检计量器具信息", menu: '/qj/instrument-0-0-0/list/0/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument/detail/:type/:id',
            name: 'Qj_instrumentDetail',
            meta: { title: "器具详情" , menu: '/qj/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
            component: () => import( '../views/instrument/Detail.vue'),
          },
          {
            path: '/qj/instrument-1-1-1/list/:check/:showOnly/:region',
            name: 'Qj_instrument-1-1-1',
            meta: { title: "强检计量器具信息", menu: '/qj/instrument-1-1-1/list/1/1/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument-0-1-1/list/:check/:showOnly/:region',
            name: 'Qj_instrument-0-1-1',
            meta: { title: "非强检计量器具信息", menu: '/qj/instrument-0-1-1/list/0/1/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument-2-1-1/list/:check/:showOnly/:region',
            name: 'Qj_instrument-2-1-1',
            meta: { title: "计量器具信息台账", menu: '/qj/instrument-2-1-1/list/2/1/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument-2-0-0/list/:check/:showOnly/:region',
            name: 'Qj_instrument-2-0-0',
            meta: { title: "计量器具信息台账", menu: '/qj/instrument-2-0-0/list/2/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instruments-2-0-0/list/:check/:showOnly/:region',
            name: 'Qj_instruments-2-0-0',
            meta: { title: "计量器具信息台账", menu: '/qj/instruments-2-0-0/list/2/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },

          {
            path: '/qj/instrument-2-0-1/list/:check/:showOnly/:region',
            name: 'Qj_instruments-2-0-1',
            meta: { title: "计量器具信息台账", menu: '/qj/instruments-2-0-1/list/2/0/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/cert/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Qj_Authorize_Cert_List',
            meta: { title: "计量授权证书列表", menu: '/qj/authorizeCert/list',name: "authorizeCertList", keepAlive: true},
            component: () => import( '../views/authorizeCert/ListV2.vue'),
          },
          {
            path: '/qj/authorizeCert/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Qj_Authorize_Cert_Detail',
            meta: { title: "计量授权证书详情", menu: '/qj/authorizeCert/detail',name: "authorizeCertDetail"},
            component: () => import( '../views/authorizeCert/Detail.vue'),
          },

          {
            path: '/qj/instrumentCompany/list/:check/:showOnly/:region/:useUnitId',
            name: 'Qj_instrument-100-0-0',
            meta: { title: "当前单位计量器具信息台账", menu: '/qj/instrument-100-0-0/list/100/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/qj/instrument/detail/:type/:id',
            name: 'Qj_instrumentDetail',
            meta: { title: "当前器具详情" , menu: '/qj/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
            component: () => import( '../views/instrument/Detail.vue'),
          }
        ]
      },
      {
        path: '/ac',
        name: 'ac',
        component: () => import( '../views/sys/Index.vue'),
        meta: {moduleId: 52},
        children: [
          {
            path: '/home/52',
            name: 'Cert_Home',
            meta: {title: "我的主页", menu: '/home/52', moduleId: 52},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/ac/cert/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Authorize_Cert_List',
            meta: { title: "计量授权证书列表", menu: '/cert/list',name: "authorizeCertList", keepAlive: true},
            component: () => import( '../views/authorizeCert/ListV2.vue'),
          },
          {
            path: '/ac/cert/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Cert_Authorize_Cert_Detail',
            meta: { title: "计量授权证书详情", menu: '/info/authorizeCert/detail',name: "authorizeCertDetail"},
            component: () => import( '../views/authorizeCert/Detail.vue'),
          }
        ]
      },
      {
        path: '/cxjl',
        name: 'cxjl',
        meta: {moduleId: 34},
        component: () => import( '../views/integrity/Layout.vue'),
        children: [
          {
            path: '/home/34',
            name: 'cxjl_Home',
            meta: {title: "我的主页", menu: '/home/34', moduleId: 34},
            component: () => import( '../views/integrity/Index.vue')
          },

          {
            path: '/cxjl/create',
            name: 'cxjl_create',
            meta: {title: "诚信计量单位创建", menu: '/cxjl/create', moduleId: 34},
            component: () => import( '../views/integrity/OrderList.vue')
          },
          {
            path: '/cxjl/audit',
            name: 'cxjl_audit',
            meta: {title: "诚信计量单位创建审校", menu: '/cxjl/audit', moduleId: 34},
            component: () => import( '../views/integrity/OrderAudit.vue')
          },
          {
            path: '/cxjl/query',
            name: 'cxjl_query',
            meta: {title: "诚信计量单位查询", menu: '/cxjl/query', moduleId: 34},
            component: () => import( '../views/integrity/List.vue')
          },
          {
            path: '/cxjl/publicity',
            name: 'cxjl_publicity',
            meta: {title: "公示列表", menu: '/cxjl/publicity', moduleId: 34},
            component: () => import( '../views/integrity/Publicity.vue')
          },
          {
            path: '/cxjl/confirm/do',
            name: 'cxjl_confirm_do',
            meta: {title: "单位年度确认", menu: '/cxjl/confirm/do', moduleId: 34},
            component: () => import( '../views/integrity/YearConfirm.vue')
          },
          {
            path: '/cxjl/confirm/query',
            name: 'cxjl_confirm_query',
            meta: {title: "单位年度确认查询", menu: '/cxjl/confirm/query', moduleId: 34},
            component: () => import( '../views/integrity/YearConfirmList.vue')
          },
          {
            path: '/cxjl/demo/list',
            name: 'cxjl_demo_list',
            meta: {title: "企业计量文化巡礼", menu: '/cxjl/demo/list', moduleId: 34},
            component: () => import( '../views/integrity/DemoList.vue')
          },
          {
            path: '/cxjl/demo/list',
            name: 'cxjl_demo_list',
            meta: {title: "企业计量文化巡礼", menu: '/cxjl/demo/list', moduleId: 34},
            component: () => import( '../views/integrity/DemoList.vue')
          },
          {
            path: '/cxjl/credit/my',
            name: 'cxjl_credit_my',
            meta: {title: "单位信用档案", menu: '/cxjl/credit/my', moduleId: 34},
            component: () => import( '../views/integrity/Credit.vue')
          },
          {
            path: '/cxjl/credit/list',
            name: 'cxjl_credit_list',
            meta: {title: "计量信用档案", menu: '/cxjl/credit/list', moduleId: 34},
            component: () => import( '../views/integrity/CreditList.vue')
          },
          {
            path: '/cxjl/complaint/list',
            name: 'cxjl_complaint_list',
            meta: {title: "投诉举报", menu: '/cxjl/complaint/list', moduleId: 34},
            component: () => import( '../views/integrity/ComplaintList.vue')
          },
          {
            path: '/cxjl/supervise/list',
            name: 'cxjl_supervise_list',
            meta: {title: "监督检查列表", menu: '/cxjl/supervise/list', moduleId: 34},
            component: () => import( '../views/integrity/SuperviseList.vue')
          },
          {
            path: '/cxjl/punish/list',
            name: 'cxjl_punish_list',
            meta: {title: "行政处罚列表", menu: '/cxjl/punish/list', moduleId: 34},
            component: () => import( '../views/integrity/PunishList.vue')
          },
          {
            path: '/cxjl/notice/list',
            name: 'cxjl_notice_list',
            meta: {title: "通知公告", menu: '/cxjl/notice/list', moduleId: 34},
            component: () => import( '../views/integrity/Notice.vue')
          }
        ]
      },
      {
        path: '/rules',
        name: 'rules',
        component: () => import( '../views/sys/Index.vue'),
        meta: { moduleId: 41 },
        children: [
          {
            path: '/home/41',
            name: 'Rules_Home',
            meta: {title: "我的主页", menu: '/home/41', moduleId: 41},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/rules/rulesLocal/list/:type',
            name: 'Rules_rulesLocal',
            meta: { title: "地方规程规范管理", menu: '/rules/rulesLocal/list/0', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/List.vue'),
          },
          {
            path: '/rules/rulesCountry/list/:type',
            name: 'Rules_rulesCountry',
            meta: { title: "国家规程规范管理", menu: '/rules/rulesCountry/list/1', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/List.vue'),
          },
          {
            path: '/rules/rulesOther/list/:type',
            name: 'Rules_rulesOther_Share',
            meta: { title: "其它规程规范管理", menu: '/rules/rulesOther/list/3', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/List.vue'),
          },
          {
            path: '/rules/rulesAll/list/:type',
            name: 'Rules_rulesLocal_Share',
            meta: { title: "规程规范共享管理", menu: '/rules/rulesAll/list/2', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/List.vue'),
          },
          {
            path: '/rules/list/:mode/:modeValue',
            name: 'RulesList',
            meta: { title: "规程规范共享管理", menu: '/rules/rulesList', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/ListV2.vue'),
          },
          {
            path: '/rules/Detail/:id/:type/:rulesType',
            name: 'Rules_rulesDetail',
            meta: { title: "规程规范管理详情", menu: '/rules/rulesAll/list/0', name: "rulesDetail" },
            component: () => import( '../views/rules/Detail.vue'),
          },
          {
            path: '/rules/mechanismAll/list/:mode',
            name: 'Rules_mechanismAll',
            meta: { title: "全部单位管理", menu: '/rules/mechanismAll/list/0000', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismSelf/list/:mode',
            name: 'Rules_mechanismSelf',
            meta: { title: "所在单位管理", menu: '/rules/mechanismSelf/list/0005', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismUse/list/:mode',
            name: 'Rules_mechanismUse',
            meta: { title: "器具使用单位", menu: '/rules/mechanismUse/list/0004', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismOfficial/list/:mode',
            name: 'Rules_mechanismOfficial',
            meta: { title: "法定技术机构", menu: '/rules/mechanismOfficial/list/0001', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismOther/list/:mode',
            name: 'Rules_mechanismOther',
            meta: { title: "其他技术机构", menu: '/rules/mechanismOther/list/0003', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismOffice/list/:mode',
            name: 'Rules_mechanismOffice',
            meta: { title: "计量行政部门", menu: '/rules/mechanismOffice/list/0002', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismEmpower/list/:mode',
            name: 'Rules_mechanismEmpower',
            meta: { title: "授权检定机构", menu: '/rules/mechanismEmpower/list/0006', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismSpecial/list/:mode',
            name: 'Rules_mechanismSpecial',
            meta: { title: "专项授权检定机构", menu: '/rules/mechanismSpecial/list/0008', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/mechanismProduce/list/:mode',
            name: 'Rules_mechanismProduce',
            meta: { title: "器具制造单位", menu: '/rules/mechanismProduce/list/300', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/rules/personListSelf/:type',
            name: 'Rules_personListSelf',
            meta: { title: "所在单位人员管理", menu: '/rules/personListSelf/5', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/personListUse/:type',
            name: 'Rules_personListUse',
            meta: { title: "器具使用单位人员", menu: '/rules/personListUse/0004', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/personListOfficial/:type',
            name: 'Rules_personListOfficial',
            meta: { title: "法定技术机构人员", menu: '/rules/personListOfficial/0001', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/personListEmpower/:type',
            name: 'Rules_personListEmpower',
            meta: { title: "授权检定机构人员", menu: '/rules/personListEmpower/0006', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/personListSpecial/:type',
            name: 'Rules_personListSpecial',
            meta: { title: "专项授权检定人员", menu: '/rules/personListSpecial/0008', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/personListProduce/:type',
            name: 'Rules_personListProduce',
            meta: { title: "器具制造单位人员", menu: '/rules/personListProduce/0007', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/personListOther/:type',
            name: 'Rules_personListOther',
            meta: { title: "其他技术机构人员", menu: '/rules/personListOther/0003', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/personListOffice/:type',
            name: 'Rules_personListOffice',
            meta: { title: "计量行政部门人员", menu: '/rules/personListOffice/0002', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/rules/userData/:type/:show/:id',
            name: 'Rules_inforUserData',
            meta: {title: "人员信息", menu: '/rules/userData/3/0/0', name: "userData"},
            component: () => import( '../views/pages/UserData.vue')
          },

          {
            path: '/rules/cert/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Rules_Authorize_Cert_List',
            meta: { title: "计量授权证书列表", menu: '/rules/authorizeCert/list',name: "authorizeCertList", keepAlive: true},
            component: () => import( '../views/authorizeCert/ListV2.vue'),
          },

          {
            path: '/rules/cert/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Rules_Authorize_Cert_Detail',
            meta: { title: "计量授权证书详情", menu: '/rules/authorizeCert/detail',name: "authorizeCertDetail"},
            component: () => import( '../views/authorizeCert/Detail.vue'),
          },

          {
            path: '/rules/chart',
            name: 'Rules_Chart',
            meta: { title: "规程规范图表", menu: '/rules/chart',name: "rulesChart", keepAlive: true},
            component: () => import( '../views/rules/Chart.vue'),
          },

          {
            path: '/rules/instrumentCompany/list/:check/:showOnly/:region/:useUnitId',
            name: 'Rules_instrument-100-0-0',
            meta: { title: "当前单位计量器具信息台账", menu: '/rules/instrument-100-0-0/list/100/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/rules/instrument/detail/:type/:id',
            name: 'Rules_instrumentDetail',
            meta: { title: "当前器具详情" , menu: '/rules/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
            component: () => import( '../views/instrument/Detail.vue'),
          }
        ]
      },
      {
        path: '/standard',
        name: 'standard',
        component: () => import( '../views/sys/Index.vue'),
        meta: { moduleId: 29 },
        children: [
          {
            path: '/home/29',
            name: 'Standard_Home',
            meta: {title: "我的主页", menu: '/home/29', moduleId: 29},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/standard/measuring/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Standard_measuring',
            meta: { title: "本单位计量标准管理", menu: '/standard/measuring/list', name: "measuringList", keepAlive: true },
            component: () => import( '../views/measuring/ListV2.vue'),
          },
          {
            path: '/standard/measuring/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Standard_measuringDetail',
            meta: { title: "计量标准详情页", menu: '/standard/measuring/detail', name: "measuringDetail" },
            component: () => import( '../views/measuring/DetailV2.vue'),
          },
          {
            path: '/standard/mechanismAll/list/:mode',
            name: 'Standard_mechanismAll',
            meta: { title: "全部单位管理", menu: '/standard/mechanismAll/list/0000', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismSelf/list/:mode',
            name: 'Standard_mechanismSelf',
            meta: { title: "所在单位管理", menu: '/standard/mechanismSelf/list/0005', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismUse/list/:mode',
            name: 'Standard_mechanismUse',
            meta: { title: "器具使用单位", menu: '/standard/mechanismUse/list/0004', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismOfficial/list/:mode',
            name: 'Standard_mechanismOfficial',
            meta: { title: "法定技术机构", menu: '/standard/mechanismOfficial/list/0001', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismOther/list/:mode',
            name: 'Standard_mechanismOther',
            meta: { title: "其他技术机构", menu: '/standard/mechanismOther/list/0003', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismOffice/list/:mode',
            name: 'Standard_mechanismOffice',
            meta: { title: "计量行政部门", menu: '/standard/mechanismOffice/list/0002', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismEmpower/list/:mode',
            name: 'Standard_mechanismEmpower',
            meta: { title: "授权检定机构", menu: '/standard/mechanismEmpower/list/0006', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismSpecial/list/:mode',
            name: 'Standard_mechanismSpecial',
            meta: { title: "专项授权检定机构", menu: '/standard/mechanismSpecial/list/0008', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/mechanismProduce/list/:mode',
            name: 'Standard_mechanismProduce',
            meta: { title: "器具制造单位", menu: '/standard/mechanismProduce/list/300', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/standard/personListSelf/:type',
            name: 'Standard_personListSelf',
            meta: { title: "所在单位人员管理", menu: '/standard/personListSelf/5', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/personListUse/:type',
            name: 'Standard_personListUse',
            meta: { title: "器具使用单位人员", menu: '/standard/personListUse/0004', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/personListOfficial/:type',
            name: 'Standard_personListOfficial',
            meta: { title: "法定技术机构人员", menu: '/standard/personListOfficial/0001', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/personListEmpower/:type',
            name: 'Standard_personListEmpower',
            meta: { title: "授权检定机构人员", menu: '/standard/personListEmpower/0006', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/personListSpecial/:type',
            name: 'Standard_personListSpecial',
            meta: { title: "专项授权检定人员", menu: '/standard/personListSpecial/0008', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/personListProduce/:type',
            name: 'Standard_personListProduce',
            meta: { title: "器具制造单位人员", menu: '/standard/personListProduce/0007', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/personListOther/:type',
            name: 'Standard_personListOther',
            meta: { title: "其他技术机构人员", menu: '/standard/personListOther/0003', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/personListOffice/:type',
            name: 'Standard_personListOffice',
            meta: { title: "计量行政部门人员", menu: '/standard/personListOffice/0002', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/standard/userData/:type/:show/:id',
            name: 'Standard_inforUserData',
            meta: {title: "人员信息", menu: '/standard/userData/3/0/0', name: "userData"},
            component: () => import( '../views/pages/UserData.vue')
          },

          {
            path: '/standard/cert/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Standard_Authorize_Cert_List',
            meta: { title: "计量授权证书列表", menu: '/standard/authorizeCert/list',name: "authorizeCertList", keepAlive: true},
            component: () => import( '../views/authorizeCert/ListV2.vue'),
          },

          {
            path: '/standard/cert/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Standard_Authorize_Cert_Detail',
            meta: { title: "计量授权证书详情", menu: '/standard/authorizeCert/detail',name: "authorizeCertDetail"},
            component: () => import( '../views/authorizeCert/Detail.vue'),
          },

          {
            path: '/standard/instrumentCompany/list/:check/:showOnly/:region/:useUnitId',
            name: 'Standard_instrument-100-0-0',
            meta: { title: "当前单位计量器具信息台账", menu: '/standard/instrument-100-0-0/list/100/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/standard/instrument/detail/:type/:id',
            name: 'Standard_instrumentDetail',
            meta: { title: "当前器具详情" , menu: '/standard/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
            component: () => import( '../views/instrument/Detail.vue'),
          },
          {
            path: '/standard/public/list/:mode/:modeValue/:orgId',
            name: 'Standard_standardCompany',
            meta: { title: "当前单位社会公用计量标准管理", menu: '/standard/standardCompany/publicList/0',name: "standardList", keepAlive: true },
            component: () => import( '../views/standard/PublicListV2.vue'),
          },
          {
            path: '/standard/standard/publicDetail/:id/:type/:mode/:manageStatus',
            name: 'Standard_standardPublicDetail',
            meta: { title: "当前社会公用计量标准详情", menu: '/standard/standardDetail/publicDetail', name: "standardDetail" },
            component: () => import( '../views/standard/PublicDetail.vue'),
          },
          {
            path: '/standard/measuring/detail//:pageType/:mode/:manageStatus/:id',
            name: 'Standard_measuringDetail',
            meta: { title: "当前计量标准详情", menu: '/standard/measuringAll/detail', name: "measuringDetail" },
            component: () => import( '../views/measuring/DetailV2.vue'),
          },
        ]
      },
      {
        path: '/sg',
        name: 'sg',
        component: () => import( '../views/sys/Index.vue'),
        meta: { moduleId: 42 },
        children: [
          {
            path: '/home/42',
            name: 'Sg_Home',
            meta: {title: "我的主页", menu: '/home/42', moduleId: 42},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/sg/public/list/:mode/:modeValue/:orgId',
            name: 'Sg_public_list',
            meta: { title: "本单位社会公用计量标准管理", menu: '/sg/public/list',name: "publicStandardList", keepAlive: true },
            component: () => import( '../views/standard/PublicListV2.vue'),
          },
          {
            path: '/sg/public/detail/:id/:type/:mode/:manageStatus',
            name: 'Sg_standardPublicDetail',
            meta: { title: "社会公用计量标准详情", menu: '/sg/standardDetail/publicDetail', name: "standardDetail" },
            component: () => import( '../views/standard/PublicDetail.vue'),
          },
          {
            path: '/sg/mechanismAll/list/:mode',
            name: 'Sg_mechanismAll',
            meta: { title: "全部单位管理", menu: '/sg/mechanismAll/list/0000', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismSelf/list/:mode',
            name: 'Sg_mechanismSelf',
            meta: { title: "所在单位管理", menu: '/sg/mechanismSelf/list/0005', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismUse/list/:mode',
            name: 'Sg_mechanismUse',
            meta: { title: "器具使用单位", menu: '/sg/mechanismUse/list/0004', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismOfficial/list/:mode',
            name: 'Sg_mechanismOfficial',
            meta: { title: "法定技术机构", menu: '/sg/mechanismOfficial/list/0001', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismOther/list/:mode',
            name: 'Sg_mechanismOther',
            meta: { title: "其他技术机构", menu: '/sg/mechanismOther/list/0003', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismOffice/list/:mode',
            name: 'Sg_mechanismOffice',
            meta: { title: "计量行政部门", menu: '/sg/mechanismOffice/list/0002', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismEmpower/list/:mode',
            name: 'Sg_mechanismEmpower',
            meta: { title: "授权检定机构", menu: '/sg/mechanismEmpower/list/0006', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismSpecial/list/:mode',
            name: 'Sg_mechanismSpecial',
            meta: { title: "专项授权检定机构", menu: '/sg/mechanismSpecial/list/0008', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/mechanismProduce/list/:mode',
            name: 'Sg_mechanismProduce',
            meta: { title: "器具制造单位", menu: '/sg/mechanismProduce/list/300', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sg/personListSelf/:type',
            name: 'Sg_personListSelf',
            meta: { title: "所在单位人员管理", menu: '/sg/personListSelf/5', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/personListUse/:type',
            name: 'Sg_personListUse',
            meta: { title: "器具使用单位人员", menu: '/sg/personListUse/0004', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/personListOfficial/:type',
            name: 'Sg_personListOfficial',
            meta: { title: "法定技术机构人员", menu: '/sg/personListOfficial/0001', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/personListEmpower/:type',
            name: 'Sg_personListEmpower',
            meta: { title: "授权检定机构人员", menu: '/sg/personListEmpower/0006', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/personListSpecial/:type',
            name: 'Sg_personListSpecial',
            meta: { title: "专项授权检定人员", menu: '/sg/personListSpecial/0008', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/personListProduce/:type',
            name: 'Sg_personListProduce',
            meta: { title: "器具制造单位人员", menu: '/sg/personListProduce/0007', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/personListOther/:type',
            name: 'Sg_personListOther',
            meta: { title: "其他技术机构人员", menu: '/sg/personListOther/0003', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/personListOffice/:type',
            name: 'Sg_personListOffice',
            meta: { title: "计量行政部门人员", menu: '/sg/personListOffice/0002', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sg/userData/:type/:show/:id',
            name: 'Sg_inforUserData',
            meta: {title: "人员信息", menu: '/sg/userData/3/0/0', name: "userData"},
            component: () => import( '../views/pages/UserData.vue')
          },

          {
            path: '/sg/instrumentCompany/list/:check/:showOnly/:region/:useUnitId',
            name: 'Sg_instrument-100-0-0',
            meta: { title: "当前单位计量器具信息台账", menu: '/sg/instrument-100-0-0/list/100/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/sg/instrument/detail/:type/:id',
            name: 'Sg_instrumentDetail',
            meta: { title: "当前器具详情" , menu: '/sg/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
            component: () => import( '../views/instrument/Detail.vue'),
          },
          {
            path: '/sg/standard/publicDetail/:id/:type/:mode/:manageStatus',
            name: 'Sg_standardPublicDetail',
            meta: { title: "当前社会公用计量标准详情", menu: '/sg/standardDetail/publicDetail', name: "standardDetail" },
            component: () => import( '../views/standard/PublicDetail.vue'),
          },
          {
            path: '/sg/measuring/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Sg_measuringCompany',
            meta: { title: "当前单位计量标准管理", menu: '/sg/measuringCompany/list/0', name: "measuringList", keepAlive: true },
            component: () => import( '../views/measuring/ListV2.vue'),
          },
          {
            path: '/sg/measuring/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Sg_measuringDetail',
            meta: { title: "当前计量标准详情", menu: '/sg/measuringAll/detail', name: "measuringDetail" },
            component: () => import( '../views/measuring/DetailV2.vue'),
          },
        ]
      },
      {
        path: '/info',
        name: 'Info',
        component: () => import( '../views/sys/Index.vue'),
        meta: { moduleId: 46 },
        children: [
          {
            path: '/home/46',
            name: 'Info_Home',
            meta: {title: "我的主页", menu: '/home/46', moduleId: 46},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/info/mechanismAll/list/:mode',
            name: 'Info_mechanismAll',
            meta: { title: "全部单位管理", menu: '/info/mechanismAll/list/0000', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismSelf/list/:mode',
            name: 'Info_mechanismSelf',
            meta: { title: "所在单位管理", menu: '/info/mechanismSelf/list/0005', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismUse/list/:mode',
            name: 'Info_mechanismUse',
            meta: { title: "器具使用单位", menu: '/info/mechanismUse/list/0004', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismOfficial/list/:mode',
            name: 'Info_mechanismOfficial',
            meta: { title: "法定技术机构", menu: '/info/mechanismOfficial/list/0001', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismOther/list/:mode',
            name: 'Info_mechanismOther',
            meta: { title: "其他技术机构", menu: '/info/mechanismOther/list/0003', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismOffice/list/:mode',
            name: 'Info_mechanismOffice',
            meta: { title: "计量行政部门", menu: '/info/mechanismOffice/list/0002', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismEmpower/list/:mode',
            name: 'Info_mechanismEmpower',
            meta: { title: "授权检定机构", menu: '/info/mechanismEmpower/list/0006', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismSpecial/list/:mode',
            name: 'Info_mechanismSpecial',
            meta: { title: "专项授权检定机构", menu: '/info/mechanismSpecial/list/0008', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/mechanismProduce/list/:mode',
            name: 'Info_mechanismProduce',
            meta: { title: "器具制造单位", menu: '/info/mechanismProduce/list/300', name: "mechanismList", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/userData/:type/:show/:id',
            name: 'Info_inforUserData',
            meta: {title: "人员信息", menu: '/info/userData/3/0/0', name: "userData"},
            component: () => import( '../views/pages/UserData.vue')
          },
          {
            path: '/info/personListOrg/:type',
            name: 'Info_personListOrg',
            meta: { title: "所在单位人员信息", menu: '/info/personListOrg/6', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListSelf/:type',
            name: 'Info_personListSelf',
            meta: { title: "所在单位人员管理", menu: '/info/personListSelf/5', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListUse/:type',
            name: 'Info_personListUse',
            meta: { title: "器具使用单位人员", menu: '/info/personListUse/0004', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListOfficial/:type',
            name: 'Info_personListOfficial',
            meta: { title: "法定技术机构人员", menu: '/info/personListOfficial/0001', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListEmpower/:type',
            name: 'Info_personListEmpower',
            meta: { title: "授权检定机构人员", menu: '/info/personListEmpower/0006', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListSpecial/:type',
            name: 'Info_personListSpecial',
            meta: { title: "专项授权检定人员", menu: '/info/personListSpecial/0008', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListProduce/:type',
            name: 'Info_personListProduce',
            meta: { title: "器具制造单位人员", menu: '/info/personListProduce/0007', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListOther/:type',
            name: 'Info_personListOther',
            meta: { title: "其他技术机构人员", menu: '/info/personListOther/0003', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListOffice/:type',
            name: 'Info_personListOffice',
            meta: { title: "计量行政部门人员", menu: '/info/personListOffice/0002', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/personListOtherPeople/:type',
            name: 'Info_personListOtherPeople',
            meta: { title: "其他人员信息", menu: '/info/personListOtherPeople/4', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/info/mechanism/list/:mode',
            name: 'Info_mechanismList',
            meta: { title: "个人绑定单位", menu: '/info/mechanism/list/200', name: "mechanismList", keepAlive: true},
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/info/instrument-1-0-0/list/:check/:showOnly/:region',
            name: 'Info_instrument-1-0-0',
            meta: { title: "强检计量器具信息", menu: '/info/instrument-1-0-0/list/1/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/instrument-0-0-0/list/:check/:showOnly/:region',
            name: 'Info_instrument-0-0-0',
            meta: { title: "非强检计量器具信息", menu: '/info/instrument-0-0-0/list/0/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/instrument/detail/:type/:id',
            name: 'Info_instrumentDetail',
            meta: { title: "器具详情" , menu: '/info/instrument-2-0-0/list/2/0/0',name: "instrumentDetail" },
            component: () => import( '../views/instrument/Detail.vue'),
          },
          {
            path: '/info/instrument-1-1-1/list/:check/:showOnly/:region',
            name: 'Info_instrument-1-1-1',
            meta: { title: "强检计量器具信息", menu: '/info/instrument-1-1-1/list/1/1/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/instrument-1-0-1/list/:check/:showOnly/:region',
            name: 'Info_instrument-1-0-1',
            meta: { title: "强检计量器具信息", menu: '/info/instrument-1-0-1/list/1/0/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/instrument-0-1-1/list/:check/:showOnly/:region',
            name: 'Info_instrument-0-1-1',
            meta: { title: "非强检计量器具信息", menu: '/info/instrument-0-1-1/list/0/1/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/instrument-2-1-1/list/:check/:showOnly/:region',
            name: 'Info_instrument-2-1-1',
            meta: { title: "计量器具信息台账", menu: '/info/instrument-2-1-1/list/2/1/1',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/instrument-2-0-0/list/:check/:showOnly/:region',
            name: 'Info_instrument-2-0-0',
            meta: { title: "计量器具信息台账", menu: '/info/instrument-2-0-0/list/2/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/cert/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Info_Authorize_Cert_List',
            meta: { title: "计量授权证书列表", menu: '/info/authorizeCert/list',name: "authorizeCertList", keepAlive: true},
            component: () => import( '../views/authorizeCert/ListV2.vue'),
          },
          {
            path: '/info/cert/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Info_Authorize_Cert_Detail',
            meta: { title: "计量授权证书详情", menu: '/info/authorizeCert/detail',name: "instrumentDetail"},
            component: () => import( '../views/authorizeCert/Detail.vue'),
          },

          {
            path: '/info/instrumentCompany/list/:check/:showOnly/:region/:useUnitId',
            name: 'Info_instrument-100-0-0',
            meta: { title: "当前单位计量器具信息台账", menu: '/info/instrument-100-0-0/list/100/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/info/instrument/detail/:type/:id',
            name: 'Info_instrumentDetail',
            meta: { title: "当前器具详情" , menu: '/info/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
            component: () => import( '../views/instrument/Detail.vue'),
          },
          {
            path: '/info/public/list/:mode/:modeValue/:orgId',
            name: 'Info_standardCompany',
            meta: { title: "当前单位社会公用计量标准管理", menu: '/info/standardCompany/publicList/0',name: "standardList", keepAlive: true },
            component: () => import( '../views/standard/PublicListV2.vue'),
          },
          {
            path: '/info/public/detail/:id/:type/:mode/:manageStatus',
            name: 'Info_standardPublicDetail',
            meta: { title: "当前社会公用计量标准详情", menu: '/info/standardDetail/publicDetail', name: "standardDetail" },
            component: () => import( '../views/standard/PublicDetail.vue'),
          },
          {
            path: '/info/measuring/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Info_measuringCompany',
            meta: { title: "当前单位计量标准管理", menu: '/info/measuringCompany/list/0', name: "measuringList", keepAlive: true },
            component: () => import( '../views/measuring/ListV2.vue'),
          },
          {
            path: '/info/measuring/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Info_measuringDetail',
            meta: { title: "当前计量标准详情", menu: '/info/measuringAll/detail', name: "measuringDetail" },
            component: () => import( '../views/measuring/DetailV2.vue'),
          },
          {
            path: '/sys/cert/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Sys_authorizeCertList',
            meta: { title: "计量授权证书列表" },
            component: () => import( '../views/authorizeCert/ListV2.vue'),
          },
        ]
      },
      {
        path: '/sys',
        name: 'Sys',
        component: () => import( '../views/sys/Index.vue'),
        meta: { moduleId: 30 },
        children: [
          {
            path: '/home/30',
            name: 'HomaPage30',
            meta: {title: "我的主页", menu: '/home/30', moduleId: 30},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/sys/change-mechanism-audit/index',
            name: 'change-mechanism-audit',
            meta: { title: "单位变更审核"},
            component: () => import( '../views/mechanism/change/audit/Index.vue'),
          },
          {
            path: '/sys/personListSelf/:type',
            name: 'Sys_personListSelf',
            meta: { title: "单位人员信息", menu: '/sys/personListSelf/5', name: "personList", keepAlive: true},
            component: () => import( '../views/information/PersonList.vue'),
          },
          {
            path: '/sys/userData/:type/:show/:id',
            name: 'Sys_inforUserData',
            meta: {title: "人员信息", menu: '/sys/userData/0/1/0', name: "userData"},
            component: () => import( '../views/pages/UserData.vue')
          },
          {
            path: '/sys/mechanism/list/:mode',
            name: 'Sys_mechanismList',
            meta: { title: "单位注册审核", menu: '/sys/mechanism/list/100', name: "mechanismList" },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sys/personAudit/:status/:type',
            name: 'Sys_Person_Audit',
            meta: {title: "个人注册审核", menu: '/sys/personAudit/0/0',name: "Sys_UserManage"},
            component: () => import( '../views/sys/UserManage.vue')
          },
          {
            path: '/sys/mechanismSelf/list/:mode',
            name: 'Sys_Mechanism_Self',
            meta: { title: "单位信息管理", menu: '/sys/mechanismSelf/list/0005', name: "Sys_Mechanism_Self", keepAlive: true },
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sys/userManageUser/:status/:type',
            name: 'Sys_Manage_User',
            meta: {title: "人员绑定审核", menu: '/sys/userManageUser/3/1',name: "Sys_UserManage"},
            component: () => import( '../views/sys/UserManage.vue')
          },
          {
            path: '/sys/userManageAll/:status/:type',
            name: 'Sys_UserManageAll',
            meta: {title: "用户管理", menu: '/sys/userManageAll/1/0',name: "Sys_UserManage"},
            component: () => import( '../views/sys/UserManage.vue')
          },
          {
            path: '/sys/userManage/:status/:type',
            name: 'Sys_UserManage',
            meta: {title: "用户管理", menu: '/sys/userManage/1/1',name: "Sys_UserManage"},
            component: () => import( '../views/sys/UserManage.vue')
          },
          {
            path: '/sys/adminRole',
            name: 'Sys_Admin_Role',
            meta: {title: "类型用户管理", menu: '/sys/adminRole', name: "Sys_Admin_Role"},
            component: () => import( '../views/sys/Role.vue')
          },
          {
            path: '/sys/role',
            name: 'Sys_Role',
            meta: {title: "角色管理", menu: '/sys/role', name: "Sys_Role"},
            component: () => import( '../views/sys/Role.vue')
          },
          {
            path: '/sys/role/resource/:id',
            name: 'Sys_Role_Resource',
            meta: {title: "角色权限管理", menu: '/sys/role', name: "Sys_Role_Resource"},
            component: () => import( '../views/sys/RoleResource.vue')
          },
          {
            path: '/sys/resource/:id',
            name: 'Sys_Resource',
            meta: {title: "权限管理", menu: '/sys/role/resource', name: "Sys_Resource"},
            component: () => import( '../views/sys/Resource.vue')
          },
          {
            path: '/sys/menu/list',
            name: 'Sys_Menu',
            meta: {title: "菜单管理", menu: '/sys/menu/list',name: "Sys_Menu"},
            component: () => import( '../views/sys/menu/List.vue')
          },
          {
            path: '/sys/notice/list',
            name: 'Sys_Notice_List',
            meta: {title: "公告管理", menu: '/sys/notice/list', name: "Sys_Notice_List"},
            component: () => import( '../views/sys/notice/List.vue')
          },
          {
            path: '/sys/notice/detail/:mode/:id',
            name: 'Sys_Notice_Detail',
            meta: {title: "公告详情", menu: '/sys/notice/detail', name: "Sys_Notice_Detail"},
            component: () => import( '../views/sys/notice/Detail.vue')
          },
          {
            path: '/sys/rule/list',
            name: 'Sys_Rule_List',
            meta: {title: "规章制度管理", menu: '/sys/rule/list', name: "Sys_Rule_List"},
            component: () => import( '../views/sys/rule/List.vue')
          },
          {
            path: '/sys/rule/detail/:mode/:id',
            name: 'Sys_Rule_Detail',
            meta: {title: "规章制度详情", menu: '/sys/rule/detail', name: "Sys_Rule_Detail"},
            component: () => import( '../views/sys/rule/Detail.vue')
          },
          {
            path: '/sys/log/list',
            name: 'Sys_Log_List',
            meta: {title: "日志", menu: '/sys/log/list', name: "Sys_Log_List"},
            component: () => import( '../views/sys/log/List.vue')
          },
          {
            path: '/sys/flow/index',
            name: 'Sys_Flow_Index',
            meta: {title: "流程管理", menu: '/sys/flow/index', name: "Sys_Flow_Index"},
            component: () => import( '../views/sys/flow/Index.vue')
          },
          {
            path: '/sys/config/index',
            name: 'Sys_Config_Index',
            meta: {title: "系统配置", menu: '/sys/config/index', name: "Sys_Config_Index"},
            component: () => import( '../views/sys/config/Index.vue')
          },
          {
            path: '/sys/SourceManage',
            name: 'Sys_SourceManage',
            meta: {title: "资源管理", menu: '/sys/SourceManage', name: "Sys_SourceManage"},
            component: () => import( '../views/sys/SourceManage.vue')
          },
          {
            path: '/sys/dept/list',
            name: 'Sys_Dept',
            meta: {title: "部门管理", menu: '/sys/dept/list', name: "Sys_Dept"},
            component: () => import( '../views/sys/dept/List.vue')
          },
          {
            path: '/sys/my/changePwd',
            name: 'changePwd',
            meta: {title: "修改密码", menu: '/sys/my/changePwd', name: "changePwd"},
            component: () => import( '../views/my/ChangePwd.vue')
          },
          {
            path: '/sys/mechanism/list/:mode',
            name: 'Sys_mechanismList',
            meta: { title: "个人绑定单位", menu: '/sys/mechanism/list/200', name: "mechanismList"},
            component: () => import( '../views/mechanism/List.vue'),
          },
          {
            path: '/sys/instrumentName',
            name: 'Sys_InstrumentName',
            meta: {title: "器具字典", menu: '/sys/instrumentName',name: "Sys_InstrumentName"},
            component: () => import( '../views/sys/InstrumentName.vue')
          },
          {
            path: '/sys/instrumentNameDetail/:type/:id',
            name: 'Sys_InstrumentName_Detail',
            meta: {title: "器具字典详情", menu: '/sys/instrumentName',name: "Sys_InstrumentName_Detail"},
            component: () => import( '../views/sys/InstrumentNameDetail.vue')
          },

          {
            path: '/sys/instrumentTree',
            name: 'Sys_Instrument_Tree',
            meta: {title: "器具分类字典", menu: '/sys/instrumentTree',name: "Sys_Instrument_Tree"},
            component: () => import( '../views/sys/InstrumentTree.vue')
          },
          {
            path: '/sys/instrumentCatalogue',
            name: 'Sys_Instrument_Catalogue',
            meta: {title: "强检目录字典", menu: '/sys/instrumentCatalogue',name: "Sys_Instrument_Catalogue"},
            component: () => import( '../views/sys/InstrumentCatalogue.vue')
          },
          {
            path: '/sys/instrumentCompany/list/:check/:showOnly/:region/:useUnitId',
            name: 'Sys_instrument-100-0-0',
            meta: { title: "当前单位计量器具信息台账", menu: '/sys/instrument-100-0-0/list/100/0/0',name: "instrumentList", keepAlive: true },
            component: () => import( '../views/instrument/List.vue'),
          },
          {
            path: '/sys/instrument/detail/:type/:id',
            name: 'Sys_instrumentDetail',
            meta: { title: "当前器具详情" , menu: '/sys/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
            component: () => import( '../views/instrument/Detail.vue'),
          },
          {
            path: '/sys/public/list/:mode/:modeValue/:orgId',
            name: 'Sys_standardCompany',
            meta: { title: "当前单位社会公用计量标准管理", menu: '/sys/standardCompany/publicList/0',name: "standardList", keepAlive: true },
            component: () => import( '../views/standard/PublicListV2.vue'),
          },
          {
            path: '/sys/standard/publicDetail/:id/:type/:mode/:manageStatus',
            name: 'Sys_standardPublicDetail',
            meta: { title: "当前社会公用计量标准详情", menu: '/sys/standardDetail/publicDetail', name: "standardDetail" },
            component: () => import( '../views/standard/PublicDetail.vue'),
          },
          {
            path: '/sys/measuring/list/:mode/:modeValue/:modeType/:orgId',
            name: 'Sys_measuringCompany',
            meta: { title: "当前单位计量标准管理", menu: '/sys/measuringCompany/list/0', name: "measuringList", keepAlive: true },
            component: () => import( '../views/measuring/ListV2.vue'),
          },
          {
            path: '/sys/measuring/detail/:pageType/:mode/:manageStatus/:id',
            name: 'Sys_measuringDetail',
            meta: { title: "当前计量标准详情", menu: '/sys/measuringAll/detail', name: "measuringDetail" },
            component: () => import( '../views/measuring/DetailV2.vue'),
          },
          {
            path: '/sys/external/:url',
            name: 'Sys_external',
            meta: { title: "承检器具设置" },
            component: () => import( '../views/external/Page.vue'),
          },
        ]
      },
      {
        path: '/todo',
        name: 'todo',
        component: () => import( '../views/sys/Index.vue'),
        meta: {moduleId: 32},
        children: [
          {
            path: '/home/32',
            name: 'Todo_Home',
            meta: {title: "我的主页", menu: '/home/32', moduleId: 32},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/todo/external/:url',
            name: 'Todo_External',
            meta: { title: "消息中心" },
            component: () => import( '../views/external/Page.vue'),
          }
        ]
      },
      {
        path: '/approval',
        name: 'approval',
        component: () => import( '../views/sys/Index.vue'),
        meta: {moduleId: 39},
        children: [
          {
            path: '/home/39',
            name: 'Approval_Home',
            meta: {title: "我的主页", menu: '/home/39', moduleId: 39},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/approval/index/:mode',
            name: 'Approval_Index',
            meta: { title: "型式批准", menu: '/approval/Index', name: "approvalIndex" },
            component: () => import( '../views/statistics/approval/Index.vue')
          }
        ]
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: () => import( '../views/sys/Index.vue'),
        meta: { moduleId: 45 },
        children: [
          {
            path: '/home/45',
            name: 'Statistics_Home',
            meta: {title: "我的主页", menu: '/home/45', moduleId: 45},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/statistics/map/:type', //type 0社会公用计量标准 1授权项目
            name: 'Maps0',
            meta: { title: "社会公用计量标准", menu: '/statistics/map/0', name: "Maps0" , keepAlive: true},
            component: () => import( '../views/pages/Map.vue'),
          },
          {
            path: '/statistics/map1/:type', //type 0社会公用计量标准 1授权项目
            name: 'Maps1',
            meta: { title: "授权项目", menu: '/statistics/map1/1', name: "Maps1" , keepAlive: true},
            component: () => import( '../views/pages/Map1.vue'),
          },
          {
            path: '/statistics/mapList', //
            name: 'MapsList',
            meta: { title: "社会公用计量标准详情", menu: '/statistics/map/0', name: "mapList" },
            component: () => import( '../views/pages/MapList.vue'),
          },
          {
            path: '/statistics/mapList2', //
            name: 'MapsList2',
            meta: { title: "授权项目详情", menu: '/statistics/map1/1', name: "mapList2" },
            component: () => import( '../views/pages/MapList2.vue'),
          },
          {
            path: '/statistics/rulesChart', //
            name: 'Rules_Chart',
            meta: { title: "规程规范统计", menu: '/statistics/rulesChart', name: "rulesChart" , keepAlive: true},
            component: () => import( '../views/rules/Chart.vue'),
          },
          {
            path: '/statistics/rulesAllChart/list/:type',
            name: 'Rules_rulesAll_Chart',
            meta: { title: "规程规范总量统计", menu: '/statistics/rulesAllChart/list/100', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/List.vue'),
          },
          {
            path: '/statistics/rulesChangeChart/list/:type',
            name: 'Rules_rulesChange_Chart',
            meta: { title: "规程规范年发布量统计", menu: '/statistics/rulesChangeChart/list/101', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/List.vue'),
          },
          {
            path: '/statistics/rulesChartAll/list/:type',
            name: 'Rules_rules_Chart_All',
            meta: { title: "规程规范统计", menu: '/statistics/rulesChartAll/list/200', name: "rulesList", keepAlive: true },
            component: () => import( '../views/rules/List.vue'),
          },
          {
            path: '/statistics/Detail/:id/:type/:rulesType',
            name: 'Statistics_rulesDetail',
            meta: { title: "规程规范详情", menu: '/statistics/rulesAllChart/list/200', name: "rulesDetail" },
            component: () => import( '../views/rules/Detail.vue'),
          },
          {
            path: '/statistics/practitionerIndexs/:mode',
            name: 'Statistics_Practitioner',
            meta: { title: "从业人员", menu: '/statistics/index/0', name: "practitionerIndexs", keepAlive: true },
            component: () => import( '../views/statistics/practitioner/Index.vue')
          },
          {
            path: '/statistics/materialIndex/:mode',
            name: 'Statistics_Index',
            meta: { title: "标准物质", menu: '/statistics/index/0', name: "statisticsIndex", keepAlive: true },
            component: () => import( '../views/statistics/material/Index.vue')
          },
          {
            path: '/statistics/approvalIndex/:mode',
            name: 'Statistics_Approval_Index',
            meta: { title: "统计分析", menu: '/statistics/approvalIndex/0', name: "statisticsApprovalIndex" },
            component: () => import( '../views/statistics/approval/Index.vue')
          },
          {
            path: '/statistics/auditIndex',
            name: 'Statistics_Audit_Index',
            meta: { title: "统计分析", menu: '/statistics/AuditIndex', name: "statisticsAuditIndex" },
            component: () => import( '../views/statistics/audit/Index.vue')
          },
          {
            path: '/statistics/auditSummary',
            name: 'Statistics_Audit_Summary',
            meta: { title: "统计分析", menu: '/statistics/AuditSummary', name: "statisticsAuditSummary" },
            component: () => import( '../views/statistics/audit/Summary.vue')
          },
          {
            path: '/statistics/inspectIndex',
            name: 'Statistics_Inspect_Order',
            meta: { title: "统计分析", menu: '/statistics/InspectIndex', name: "statisticsInspectOrder" },
            component: () => import( '../views/statistics/inspect/Index.vue')
          },

          {
            path: '/statistics/statisIndex/:mode',
            name: 'Statistics_Statis_Index',
            meta: { title: "统计分析", menu: '/statistics/StatisIndex', name: "statisticsStatisIndex" },
            component: () => import( '../views/statistics/inspect/AppIndex.vue')
          },
          {
            path: '/statistics/workIndex',
            name: 'Statistics_Work_Index',
            meta: { title: "检定工作分析", menu: '/statistics/WorkIndex', name: "StatisticsWorkIndex" },
            component: () => import( '../views/statistics/inspect/WorkIndex.vue')
          },
          {
            path: '/statistics/cxjl/index',
            name: 'Statistics_CXJL_Index',
            meta: { title: "诚信计量分析", menu: '/statistics/cxjl/index', name: "Statistics_CXJL_Index" },
            component: () => import( '../views/statistics/cxjl/Index.vue')
          }
        ]
      },

      {
        path: '/regulations',
        name: 'regulations',
        component: () => import( '../views/sys/Index.vue'),
        meta: {moduleId: 40},
        children: [
          {
            path: '/home/40',
            name: 'Regulations_Home',
            meta: {title: "我的主页", menu: '/home/40', moduleId: 40},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/regulations/list/:mode/:modeValue',
            name: 'Reg_List',
            meta: {title: "法律法规", menu: '/home/45', moduleId: 40},
            component: () => import( '../views/regulations/List.vue')
          },
          {
            path: '/regulations/detail/:id/:mode/:type',
            name: 'Reg_Detail',
            meta: {title: "法律法规", menu: '/home/45', moduleId: 40},
            component: () => import( '../views/regulations/Detail.vue')
          },
        ]
      },
      {
        path: '/material',
        name: 'material',
        component: () => import( '../views/sys/Index.vue'),
        meta: {moduleId: 47},
        children: [
          {
            path: '/home/47',
            name: 'Material_Home',
            meta: {title: "我的主页", menu: '/home/47', moduleId: 47},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/material/list/:mode/:modeValue',
            name: 'Material_List',
            meta: {title: "标准物质", menu: '/home/47', moduleId: 47},
            component: () => import( '../views/material/List.vue')
          },

          {
            path: '/material/orgMaterialList/:modeValue/:mainDevOrgId',
            name: 'Org_Material_List',
            meta: {title: "企业标准物质", menu: '/home/47', moduleId: 47},
            component: () => import( '../views/material/List.vue')
          },
          {
            path: '/material/detail/:id/:mode/:type',
            name: 'Material_Detail',
            meta: {title: "标准物质", menu: '/home/47', moduleId: 47},
            component: () => import( '../views/material/Detail.vue')
          },

          {
            path: '/material/orgList',
            name: 'Material_mechanismOther',
            meta: { title: "标准物质生产单位管理", menu: '/material/MaterialOrgList'},
            component: () => import( '../views/material/MaterialOrgList.vue'),
          },
        ]
      },
        // 协同办公 OA
      {
        path: '/oa',
        name: 'oa',
        component: () => import( '../views/oa/Index.vue'),
        meta: {moduleId: 33},
        children: [
          {
            path: '/home/33',
            name: 'Oa_Home',
            meta: {title: "我的主页", menu: '/home/33', moduleId: 33},
            component: () => import( '../views/pages/Homepage.vue')
          },
          {
            path: '/oa/project',
            name: 'Oa_project',
            meta: { title: "项目档案", menu: '/oa/project', name: "oaProject" },
            component: () => import( '../views/oa/project.vue')
          },
          {
            path: '/oa/record',
            name: 'Oa_record',
            meta: { title: "机房巡查记录", menu: '/oa/record', name: "oaRecord" },
            component: () => import( '../views/oa/record.vue')
          },
          {
            path: '/oa/research',
            name: 'Oa_research',
            meta: { title: "科研管理", menu: '/oa/research', name: "oaResearch" },
            component: () => import( '../views/oa/research.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/sys/SourceManage2',
    name: 'Sys_SourceManage2',
    meta: {title: "资源管理"},
    component: () => import( '../views/sys/SourceManage.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {title: "登录"},
    component: () => import( '../views/LoginV2.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    meta: {title: "退出登录"},
    component: () => import( '../views/logout.vue')
  },
  {
    path: '/mobileImg',
    name: 'mobileImg',
    component: () => import( '../views/standard/mobileImg.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import( '../views/Demo.vue'),
  },
  {
    path: '/demoTs',
    name: 'demoTs',
    component: () => import( '../views/DemoTs.vue'),
  },
  // {
  //   path: '/map/:type', //type 0社会公用计量标准 1授权证书
  //   name: 'Maps',
  //   component: () => import( '../views/pages/Map.vue'),
  // },
  // {
  //   path: '/mapList',
  //   name: 'MapsList',
  //   component: () => import( '../views/pages/MapList.vue'),
  // },
  // {
  //   path: '/mapList2',
  //   name: 'MapsList2',
  //   component: () => import( '../views/pages/MapList2.vue'),
  // },
  {
    path: '/wechat',
    name: 'wechatHome',
    meta: {title: "微信"},
    component: () => import( '../views/sys/Index.vue'),
    //注意父子级关系
    children: [
      {
        path: '/wechat/authorize',
        name: 'WechatAuthorize',
        meta: {
          title: "微信认证",
        },
        component: () => import( '../views/wechat/Authorize.vue')
      }
    ]
  },
  {
    path: '/mp',
    name: 'mpHome',
    meta: {title: "公众号"},
    component: () => import( '../views/mp/appHome.vue'),
    //注意父子级关系
    children: [
      {
        path: '/mp/login',
        name: 'mpLogin',
        meta: {
          title: "登录页",
        },
        component: () => import( '../views/mp/Login.vue')
      },
      {
        path: '/mp/code',
        name: 'mpCode',
        meta: {
          title: "登录页",
        },
        component: () => import( '../views/mp/Code.vue')
      },
      {
        path: '/mp/index',
        name: 'mpIndex',
        meta: {
          title: "首页",
          keepAlive: true,
          isBack: false
        },
        component: () => import( '../views/mp/Index.vue')
      },
      {
        path: '/mp/detail/:id',
        name: 'mpDetail',
        meta: {title: "详情页"},
        component: () => import( '../views/mp/OrganizationDetail.vue')
      }
    ]
  },

  //  统计分析不登录访问****************************************
  {
    path: '/statistics/practitionerIndexs/:mode',
    name: 'Statistics_Practitioner',
    meta: { title: "从业人员", menu: '/statistics/practitionerIndexs/0', name: "statisticsPractitioner" },
    component: () => import( '../views/statistics/practitioner/Index.vue')
  },
  {
    path: '/statistics/materialIndexs/:mode',
    name: 'Statistics_Indexs',
    meta: { title: "标准物质", menu: '/statistics/materialIndex/0', name: "statisticsIndex" },
    component: () => import( '../views/statistics/material/Index.vue')
  },
  {
    path: '/statistics/approvalIndexs/:mode',
    name: 'Statistics_Approval_Indexs',
    meta: { title: "型式批准", menu: '/statistics/approvalIndex/0', name: "statisticsApprovalIndex" },
    component: () => import( '../views/statistics/approval/Index.vue')
  },
  {
    path: '/statistics/maps/:type', //type 0社会公用计量标准 1授权项目
    name: 'Maps0s',
    meta: { title: "社会公用计量标准", menu: '/map/0', name: "Maps0" },
    component: () => import( '../views/pages/Map.vue'),
  },
  {
    path: '/statistics/map1s/:type', //type 0社会公用计量标准 1授权项目
    name: 'Maps1s',
    meta: { title: "授权项目", menu: '/map/1', name: "Maps1" },
    component: () => import( '../views/pages/Map1.vue'),
  },
  {
    path: '/statistics/mapLists', //
    name: 'MapsLists',
    meta: { title: "社会公用计量标准详情", menu: '/mapList', name: "mapList" },
    component: () => import( '../views/pages/MapList.vue'),
  },
  {
    path: '/statistics/mapList2s', //
    name: 'MapsList2s',
    meta: { title: "授权项目详情", menu: '/mapList2', name: "mapList2" },
    component: () => import( '../views/pages/MapList2.vue'),
  },
  {
    path: '/statistics/rulesChartAll/lists/:type',
    name: 'Rules_rules_Chart_Alls',
    meta: { title: "规程规范统计", menu: '/statistics/rulesChartAll/list/200', name: "rulesList" },
    component: () => import( '../views/rules/List.vue'),
  },
  {
    path: '/statistics/Details/:id/:type/:rulesType',
    name: 'Statistics_rulesDetails',
    meta: { title: "规程规范详情", menu: '/statistics/rulesAllChart/list/200', name: "rulesDetail" },
    component: () => import( '../views/rules/Detail.vue'),
  },
  //  统计分析不登录访问end****************************************

  //外部直接访问，不带头部和菜单**********************
    //单位***
  {
    path: '/external/mechanismAll/list/:mode',
    name: 'External_mechanismAll',
    meta: { title: "全部单位管理", menu: '/external/mechanismAll/list/0000', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismSelf/list/:mode',
    name: 'External_mechanismSelf',
    meta: { title: "所在单位管理", menu: '/external/mechanismSelf/list/0007', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismUse/list/:mode',
    name: 'External_mechanismUse',
    meta: { title: "器具使用单位", menu: '/external/mechanismUse/list/0004', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismOfficial/list/:mode',
    name: 'External_mechanismOfficial',
    meta: { title: "法定技术机构", menu: '/external/mechanismOfficial/list/0001', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismOther/list/:mode',
    name: 'External_mechanismOther',
    meta: { title: "其他技术机构", menu: '/external/mechanismOther/list/0003', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismOffice/list/:mode',
    name: 'External_mechanismOffice',
    meta: { title: "计量行政部门", menu: '/external/mechanismOffice/list/0002', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismEmpower/list/:mode',
    name: 'External_mechanismEmpower',
    meta: { title: "授权检定机构", menu: '/external/mechanismEmpower/list/0006', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismSpecial/list/:mode',
    name: 'External_mechanismSpecial',
    meta: { title: "专项授权检定机构", menu: '/external/mechanismSpecial/list/0008', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  {
    path: '/external/mechanismProduce/list/:mode',
    name: 'External_mechanismProduce',
    meta: { title: "器具制造单位", menu: '/external/mechanismProduce/list/300', name: "mechanismList", keepAlive: true },
    component: () => import( '../views/mechanism/List.vue'),
  },
  //单位end***

    //人员****
  {
    path: '/external/userData/:type/:show/:id',
    name: 'External_inforUserData',
    meta: {title: "人员信息", menu: '/external/userData/3/0/0', name: "userData"},
    component: () => import( '../views/pages/UserData.vue')
  },
  {
    path: '/external/personListSelf/:type',
    name: 'External_personListSelf',
    meta: { title: "所在单位人员管理", menu: '/external/personListSelf/5', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListUse/:type',
    name: 'External_personListUse',
    meta: { title: "器具使用单位人员", menu: '/external/personListUse/0004', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListOfficial/:type',
    name: 'External_personListOfficial',
    meta: { title: "法定技术机构人员", menu: '/external/personListOfficial/0001', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListEmpower/:type',
    name: 'External_personListEmpower',
    meta: { title: "授权检定机构人员", menu: '/external/personListEmpower/0006', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListSpecial/:type',
    name: 'External_personListSpecial',
    meta: { title: "专项授权检定人员", menu: '/external/personListSpecial/0008', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListProduce/:type',
    name: 'External_personListProduce',
    meta: { title: "器具制造单位人员", menu: '/external/personListProduce/0007', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListOther/:type',
    name: 'External_personListOther',
    meta: { title: "其他技术机构人员", menu: '/external/personListOther/0003', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListOffice/:type',
    name: 'External_personListOffice',
    meta: { title: "计量行政部门人员", menu: '/external/personListOffice/0002', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  {
    path: '/external/personListOtherPeople/:type',
    name: 'External_personListOtherPeople',
    meta: { title: "其他人员信息", menu: '/external/personListOtherPeople/4', name: "personList", keepAlive: true},
    component: () => import( '../views/information/PersonList.vue'),
  },
  //人员****end

    //单位三个按钮
  {
    path: '/external/instrumentCompany/list/:check/:showOnly/:region/:useUnitId',
    name: 'External_instrument-100-0-0',
    meta: { title: "当前单位计量器具信息台账", menu: '/external/instrument-100-0-0/list/100/0/0',name: "instrumentList", keepAlive: true },
    component: () => import( '../views/instrument/List.vue'),
  },
  {
    path: '/external/instrument/detail/:type/:id',
    name: 'External_instrumentDetail',
    meta: { title: "当前器具详情" , menu: '/external/instrument-2-0-0/list/2/0/0',name: "instrumentDetail"},
    component: () => import( '../views/instrument/Detail.vue'),
  },
  {
    path: '/external/public/list/:mode/:modeValue/:orgId',
    name: 'External_standardCompany',
    meta: { title: "当前单位社会公用计量标准管理", menu: '/external/standardCompany/publicList/0',name: "standardList", keepAlive: true },
    component: () => import( '../views/standard/PublicListV2.vue'),
  },
  {
    path: '/external/standard/publicDetail/:id/:type/:mode/:manageStatus',
    name: 'External_standardPublicDetail',
    meta: { title: "当前社会公用计量标准详情", menu: '/external/standardDetail/publicDetail', name: "standardDetail" },
    component: () => import( '../views/standard/PublicDetail.vue'),
  },
  {
    path: '/external/measuring/list/:mode/:modeValue/:modeType/:orgId',
    name: 'External_measuringCompany',
    meta: { title: "当前单位计量标准管理", menu: '/external/measuringCompany/list/0', name: "measuringList", keepAlive: true },
    component: () => import( '../views/measuring/ListV2.vue'),
  },
  {
    path: '/external/measuring/detail/:pageType/:mode/:manageStatus/:id',
    name: 'External_measuringDetail',
    meta: { title: "当前计量标准详情", menu: '/external/measuringAll/detail', name: "measuringDetail" },
    component: () => import( '../views/measuring/DetailV2.vue'),
  },
  {
    path: '/external/oa/project',
    name: 'External_OaProject',
    meta: { title: "项目档案", menu: '/external/oa/project', name: "oaProject" },
    component: () => import( '../views/oa/project.vue'),
  },
  {
    path: '/external/oa/record',
    name: 'External_OaRecord',
    meta: { title: "机房巡查记录", menu: '/external/oa/record', name: "oaRecord" },
    component: () => import( '../views/oa/record.vue'),
  },
  {
    path: '/iQR',
    name: 'Integrity_QRcode',
    meta: { title: "计量中心-诚信计量", name: "iQR" },
    component: () => import( '../views/integrity/QRcodePage.vue'),
  },
  //外部直接访问，不带头部和菜单**********************

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to:Route, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + " - 河北省计量业务应用平台";
  }
  if(to.meta && to.meta.name){
    if(from.meta && from.meta.name){
      const fromDetail = from.meta.name.toLowerCase().indexOf("detail") > -1;
      const fromUserData = from.meta.name.toLowerCase().indexOf("userdata") > -1;
      const formAuthorizeCertList = (from.meta.name === "authorizeCertList") || (from.meta.name === "instrumentList") || (from.meta.name === "standardList") || (from.meta.name === "measuringList");
      const toMechanismList = (to.meta.name === "mechanismList");
      if (fromDetail || fromUserData) {
        to.meta.isBack = true;
      } else if(formAuthorizeCertList && toMechanismList) {
        to.meta.isBack = true;
      } else {
        to.meta.isBack = false;
      }
    }
  }
  next();
})

export default router
